import React from 'react';
import {Bookmarks, EventBusy, Favorite, Kitchen, RestaurantMenu, Schedule} from "@material-ui/icons";

const LandingFirstText = () => {
  return (
    <div className="landing-first">
      {/*<div className="logo-container">
        <img src="/images/cook-at-home.webp" loading="lazy" />
      </div>*/}
      <div className="first-text">
        <h2>
          We Come To Your Home!
        </h2>

        <div className="content-wrapper">
          <div className="content">
            <div className="ccdiv">
              <EventBusy style={{ fontSize: 50 }} />
              <p>We understand people have busy lives.</p>
            </div>
            <div className="non-ccdiv">
              <Bookmarks style={{ fontSize: 50, color: '#ff8000' }} />
              <p>At Cuisine Crafters, we can help you book a private chef that fits your budget, schedule, and food and nutrition preferences.</p>
            </div>
          </div>

          <div className="content content-reverse">
            <div className="non-ccdiv">
              <Schedule style={{ fontSize: 50, color: '#ff8000' }} />
              <p>Don't waste time cooking or buying groceries when you can have a personal, private chef handle all that for you.</p>
            </div>
            <div className="ccdiv">
              <Kitchen style={{ fontSize: 50 }} />
              <p>Our chefs come to your house with prepped ingredients and can cook onsite.</p>
            </div>
          </div>

          <div className="content">
            <div className="ccdiv">
              <RestaurantMenu style={{ fontSize: 50 }} />
              <p>You will have a freshly chef-prepared meal that keeps things interesting.</p>
            </div>
            <div className="non-ccdiv">
              <Favorite style={{ fontSize: 50, color: '#ff8000' }} />
              <p>Our chefs use quality ingredients and can deliver a unique experience.</p>
            </div>
          </div>
        </div>

        {/*<p>
          We understand people have busy lives.<br /><br />
          <span style={{ color: "#ff8000" }}>At Cuisine Crafters, we can help you book a private chef that fits your budget, schedule, and food and nutrition preferences.</span><br /><br />
          Don't waste time cooking or buying groceries when you can have a personal, private chef handle all that for you. <br /><br />
          <span style={{ color: "#ff8000" }}>Our chefs come to your house with prepped ingredients and can cook onsite.</span><br /><br />
          You will have a freshly chef-prepared meal that keeps things interesting.<br /><br />
          <span style={{ color: "#ff8000" }}>Our chefs use quality ingredients and can deliver a unique experience.</span>
        </p>*/}
      </div>
    </div>
  );
};

export default LandingFirstText;
